export default function GetCount(nameCountry, dataCount) {
  let EUMeasures;

  // If the query contains measures for EU, return the number.
  for (let i = 0; i < dataCount.length; i++) {
    if (dataCount[i].Countries === "European Union") {
      EUMeasures = dataCount[i]["nr_measures"];
    }
  }

  let countMeasures;

  // If the query contains the name of the country send via this function, it returns the amount of
  for (let i = 0; i < dataCount.length; i++) {
    if (dataCount[i].Countries === nameCountry) {
      countMeasures = dataCount[i]["nr_measures"];
    }
  }

  // If country doesn't have own measures, return only EU Measures, if country does have measures, Add EUMeasures to them.
  return countMeasures !== undefined ? countMeasures + EUMeasures : EUMeasures;
}
